const isTypeOf = (type) => (value) => typeof value === type;
export default isTypeOf;
